import { memo } from 'react';

import { BoardsIcon } from '@air/design-icons';

import { workspaceAgentPanelPill } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentPanelPillChrome';

export type WorkspaceAgentBoardListPillProps = {
  boardCount: number;
};

/** Inert on purpose: a group of boards has nothing single to preview or navigate to. */
export const WorkspaceAgentBoardListPill = memo(({ boardCount }: WorkspaceAgentBoardListPillProps) => (
  <span className={workspaceAgentPanelPill()} data-testid="WORKSPACE_AGENT_MESSAGE_BOARD_LIST_PILL">
    <BoardsIcon aria-hidden className="shrink-0 ads:text-icon-default text-gray-10" size="sm" />
    <span className="truncate">{boardCount === 1 ? '1 board' : `${boardCount} boards`}</span>
  </span>
));

WorkspaceAgentBoardListPill.displayName = 'WorkspaceAgentBoardListPill';
